import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PermisiuniActiuniService } from '../permisiuni-actiuni.service';
import { PermisiuniService } from '../../permisiuni/permisiuni.service';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { IPermisiune } from '../../permisiuni/permisiuni.interface';

@Component({
  selector: 'app-add-permisiuni-actiuni',
  templateUrl: './add-permisiuni-actiuni.component.html',
  styleUrls: ['./add-permisiuni-actiuni.component.scss']
})
export class AddPermisiuniActiuniComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isPermisiuniLoading = true;
  permisiuni$!: Observable<IPermisiune[]>

  form: FormGroup = new FormGroup({
    name: new FormControl(''),
    slug: new FormControl(''),
    id_permission: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPermisiuniActiuniComponent>,
    private permisiuniActiuniService: PermisiuniActiuniService,
    private permisiuniService: PermisiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
     this.getPermisiuniList();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.permisiuniActiuniService.setToken(token);
    })
  }

  getPermisiuniList() {
    this.permisiuni$ = this.permisiuniService.getPermisiuniList();
    this.permisiuni$
    .pipe(
      finalize(() => (this.isPermisiuniLoading = false))
    )
    .subscribe({
      next: (permisiuni) => {
        this.permisiuni$ = of(permisiuni);
        this.isPermisiuniLoading = false;
      },
      error: () => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        this.isPermisiuniLoading = false;
      },
    });
  }

  submitForm() {
    this.isLoading = true;

    const permisiuniActiune = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      id_permission: this.form.get('id_permission')?.value,
    };

    this.permisiuniActiuniService.addPermisiuniActiune(permisiuniActiune)
      .pipe(
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: () => {
          let errorMessage = environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        },
      });
  }
}
